import React ,{useEffect}from "react";
import {dateFormat,dateFormatAccToTimeZone,utcDateTimeWithTimeZoneWithFormat} from "../../services/Util";
import {  useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from "react-router-dom";
import {  useSelector} from "react-redux";
import Constants from "../../Constants";
import $ from 'jquery'
export default function ActivityList(props) {
  let output = props?.activity?.output;
  const navigate = useNavigate()
  let contextURL = props?.activity?.recentActivityVO?.contextUrl;
 const { t } = useTranslation();
  const activity = props.activity
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const redirectToActivity = (e,actionUrl,activity) =>{
    var projectId = ''
    const url = e.target.href
    var urlParts= ''
    var urlLastPart = ''
    if(activity.entity.entityType === "project"){
      projectId = activity.entity.id
    }
    if(url && url !== ''){
      urlLastPart = url.split("/").pop()
      urlParts = url.split("/")
    }
    const urlSecondLast = urlParts[urlParts.length -2]
     if(e.target.href === e.target.baseURI || 
      (activity.recentActivityVO.languageCode !== '' && urlSecondLast === 'language') || 
      urlLastPart === 'translationRequest' || urlSecondLast === 'changeOrder' ||
      urlLastPart === 'bids' || urlSecondLast === 'discussions'
      ){
      e.preventDefault()
      if(activity.recentActivityVO.languageCode !== '' && urlSecondLast === 'language'){
        navigate(`/project/${projectId}`,{state:{langCode:activity.recentActivityVO.languageCode}})
      }
      else if(urlLastPart === 'translationRequest' || urlLastPart === 'bids'){
         navigate(`/project/${projectId}`,{state:{tab:urlLastPart}})
      }
      else if(urlSecondLast === 'changeOrder'){
        navigate(`/project/${projectId}`,{state:{tab:urlSecondLast,id:urlLastPart}})
      }
      else if(urlSecondLast === 'discussions'){
        navigate(`/project/${projectId}`,{state:{tab:urlSecondLast,id:urlLastPart}})
      }
      }
  }
  
  return (
    <>
      <div className="created-task-list">  
        <div className="list-top-content flex">
          <div className="left">
            <strong dangerouslySetInnerHTML={{__html: output}}  onClick={(e)=> redirectToActivity(e,activity?.action[0]?.url?.substring(activity?.action[0]?.url),activity)}></strong>
            <p dangerouslySetInnerHTML={{__html: contextURL}} onClick={(e)=> redirectToActivity(e,activity?.action[0]?.url?.substring(activity?.action[0]?.url),activity)}></p>
          </div>
          <div className="right">
            <strong>{activity?.createdDate?.timeOfDay}</strong>
          </div>
        </div>
        <div className="list-bottom-content ">
        <div className="left">
          <p>
            <strong>{activity.recentActivityVO.projectName} </strong> {activity?.language !== '' ? '- '+activity?.language  : '' } <span> </span> 
             ( { activity?.recentActivityVO?.department} )
          </p>
          </div>
        </div>
      </div>
    </>
  );
}
